export default "__VITE_ASSET__$CE8dSes__"